import { DialogActions, Paper, styled } from "@mui/material";
import { toPx } from "../MuiHelpers";
import { HeadingS } from "../Typography";

export const ModalPaper = styled(Paper)<{ width: number | string }>(({ theme, width }) =>
    theme.unstable_sx({
        py: theme.spacing(6),
        px: theme.spacing(4),
        width: toPx(width),
        borderRadius: theme.shape.borderRadius,
        position: "relative",
    }),
);

export const ModalDialogTitle = styled(HeadingS)(({ theme }) =>
    theme.unstable_sx({
        py: theme.spacing(4),
        px: theme.spacing(5),
        mb: 0,
    }),
);

export const ModalDialogActions = styled(DialogActions)({
    display: "flex",
    justifyContent: "space-between",
});
